module.exports = __webpack_public_path__ + "img/pro_ar_05.1fc34894.png";